import { Link } from 'react-router-dom';
import ThankYouSEO from '../components/seo/ThankYouSEO';
import backgroundImage from '../static/background.png';

const ThankYou = () => {
  return (
    <main 
      className="min-h-screen flex items-center justify-center px-4 py-8"
      style={{ 
        backgroundImage: `url(${backgroundImage})`, 
        backgroundSize: 'cover', 
        backgroundPosition: 'center' 
      }}
    >
      <ThankYouSEO />
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <section className="max-w-3xl w-full shadow-2xl rounded-2xl overflow-hidden relative z-10">
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        <div className="relative z-10 p-8 text-center">
        <h1 className="text-4xl font-bold text-white mb-4 drop-shadow-lg">Thank You!</h1>
        <p className="text-xl text-orange-200 mb-6 drop-shadow-lg">
          We've received your message. We'll get back to you soon.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link to="/" className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-semibold transition-colors shadow-lg">Go Home</Link>
          <Link to="/contact" className="px-6 py-3 bg-white hover:bg-gray-100 text-gray-800 rounded-lg font-semibold transition-colors shadow-lg">Contact Again</Link>
        </div>
        </div>
      </section>
    </main>
  );
};

export default ThankYou;
